<template>
	<div class="modal fade" id="modal-cadastro-setor">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">

				<div class="modal-header">
					<h4 class="modal-title">{{ view_nome.setor_nome }}</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<img :src="logotipo" style="width: 16%; margin-left: 42%;">
						</div>
					</div>

					<div class="row">
						<div class="col-lg-6">
							<div class="form-group">
								<label>Nome</label>
								<input type="text" class="form-control form-control-sm"
									:class="[(setor.NAME) ? '' : incomplete]" v-model="setor.NAME">
							</div>
						</div>

						<div class="col-lg-6">
							<div class="form-group">
								<label>Ramal principal</label>
								<input type="text" class="form-control form-control-sm"
									:class="[(setor.EXTENSION) ? '' : incomplete]" v-model.number="setor.EXTENSION">
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-3">
							<div class="form-group">
								<label>Tempo de transbordo</label>
								<input type="number" class="form-control form-control-sm" min="6" max="30"
									v-model.number="setor.TEMPOTRANSBORDO">
							</div>
						</div>

						<div class="col-lg-6">
							<div class="form-group">
								<label>Ramais de transbordo</label>
								<input type="text" class="form-control form-control-sm" @change="replace_transb"
									v-model="setor.TRANSBORDO">
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer">
					<button class="btn btn-danger btn-sm" v-if="action == 'view'" @click="deletar">Deletar</button>
					<button class="btn btn-warning btn-sm" v-if="action == 'view'" @click="atualizar">Atualizar</button>
					<button class="btn btn-success btn-sm" v-if="action == 'add'" @click="adicionar">Inserir</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from "@/mixins/api.js"
import alert from "@/components/Tools/alert.vue"

export default {
	name: "modal-setor",
	props: ['setor', 'action'],
	mixins: [api],

	data: () => {
		return {
			incomplete: false,
			unidades: {
				status: null,
				result: null
			},

			alert: {
				type: "",
				name: "alert-modal-user",
				msg: ""
			}
		}
	},

	created() {
		this.get_unidades();
	},

	computed: {
		logotipo() {
			return this.$store.state.config.logotipo;
		},

		view_nome() {
			return this.$store.state.config_view_menu;
		},
	},

	methods: {
		async get_unidades() {
			this.unidades = await this.GET("Unidade");
		},

		autocomplete_phone() {
			this.unidades.result.forEach(index => (index.id == this.setor.PARENT_ID) ? this.setor.PHONE_NUMBER = index.telefone : '');
		},

		checkEmpty() {
			if (!this.setor.TEMPOTRANSBORDO) {
				this.setor.TEMPOTRANSBORDO = 0;
			}
		},

		async adicionar() {
			//
			//	Verifica se todos os dados foram preenchidos
			//
			//if ( !this.setor.TYPE || !this.setor.PARENT_ID || !this.setor.EXTENSION || !this.setor.NAME || !this.setor.START_TIME || !this.setor.END_TIME ) 
			if (!this.setor.EXTENSION || !this.setor.NAME) {
				window.alert("Preencha os campos obrigatórios!");
				this.incomplete = "focus";
			} else {
				this.checkEmpty();
				console.log(this.setor);
				const response = await this.POST("Setor/novo", this.setor);

				if (response.status == "success") {
					this.$emit("alert", { status: "success", result: "Setor adicionado com sucesso." });
				} else {
					window.alert(response.result);
				}
			}
		},

		async atualizar() {
			//
			//	Verifica se todos os dados foram preenchidos
			//
			//if ( !this.setor.TYPE || !this.setor.PARENT_ID || !this.setor.EXTENSION || !this.setor.NAME || !this.setor.START_TIME || !this.setor.END_TIME ) 				
			if (!this.setor.EXTENSION || !this.setor.NAME) {
				window.alert("Preencha os campos obrigatórios!")
				this.incomplete = "focus"
			} else {
				const response = await this.PUT("Setor", this.setor);

				if (response.status == "success") {
					this.$emit("alert", { status: "success", result: "Setor atualizada com sucesso com sucesso." });
				} else {
					window.alert(response.result);
				}
			}
		},

		async deletar() {
			if (window.confirm(`Isso irá deletar setor ${this.setor.NAME} permanentemente.`)) {
				const response = await this.DELETE('Setor', this.setor.ID);
				if (response.status == "success") {
					this.$emit("alert", response);
				} else {
					window.alert(response.result);
				}
			}
		},

		replace_transb() {
			this.setor.TRANSBORDO = this.setor.TRANSBORDO.replace(/\D/g, ",");
		}
	}
}
</script>

<style scoped></style>